
import UserContext from '@context/UserContext';
import PromoCodeForm from '@forms/PromoCode';
import PromoCodeBatchForm from '@forms/PromoCodeBatch';
import Sentry from '@integrations/Sentry';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { PromoCodeValues } from '@schema/PromoCodeSchema';
import React, { useState } from 'react';


type PromoCodeDialogArgs = {
  userContext: UserContext;
  title?: string;
  batch?: 'create' | 'edit';
  initialValues?: PromoCodeValues;
  onSubmit: (values: guesthouse.Coupon) => Promise<unknown>;
  resolve: (values: PromoCodeValues) => void;
  reject: (e?: Error | boolean) => void;
}

const PromoCodeDialog: React.FC<PromoCodeDialogArgs> = ({
  resolve,
  reject,
  userContext,
  title = 'Promo Code',
  onSubmit = async (values) => values,
  initialValues,
  batch,
}) => {
  const [open, setOpen] = useState(true);
  const [error, setError] = useState(null);
  const Form = batch === 'create' ? PromoCodeBatchForm : PromoCodeForm;

  return (
    <UserContext.Provider value={userContext}>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogTitle>
          {title}
        </DialogTitle>

        <DialogContent>
          <Form
            initialValues={initialValues}
            error={error}
            submitText="Save"
            batch={batch}
            onSubmit={(values) => {
              return onSubmit(values)
                .then((values) => {
                  setOpen(false);
                  return values;
                })
                .then(resolve)
                .catch(e => {
                  setError(e.message);
                  Sentry.captureException(e);
                });
            }}
          />
        </DialogContent>

        <DialogActions style={{ justifyContent: 'center' }}>
          <Button
            size="small"
            onClick={() => {
              setOpen(false);
              reject(false);
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </UserContext.Provider>
  );
};


export default PromoCodeDialog;
